// Generic card rarities that work across all trading card games

export type CardRarity =
  | 'common'
  | 'uncommon'
  | 'rare'
  | 'ultra_rare'
  | 'secret_rare'
  | 'promo'
  | 'vintage';

export const RARITY_LABELS: Record<CardRarity, string> = {
  common: 'Common',
  uncommon: 'Uncommon',
  rare: 'Rare',
  ultra_rare: 'Ultra Rare',
  secret_rare: 'Secret Rare',
  promo: 'Promo',
  vintage: 'Vintage',
};

export const RARITY_OPTIONS: { value: CardRarity; label: string }[] = [
  { value: 'common', label: 'Common' },
  { value: 'uncommon', label: 'Uncommon' },
  { value: 'rare', label: 'Rare' },
  { value: 'ultra_rare', label: 'Ultra Rare' },
  { value: 'secret_rare', label: 'Secret Rare' },
  { value: 'promo', label: 'Promo' },
  { value: 'vintage', label: 'Vintage' },
];

// Rarity tiers for filtering (grouped by collector value)
export const RARITY_TIERS = {
  common: ['common', 'uncommon'],
  rare: ['rare'],
  ultra: ['ultra_rare', 'secret_rare'],
  special: ['promo', 'vintage'],
} as const;

// Map legacy/game-specific rarities to consolidated values
export const RARITY_MAPPING: Record<string, CardRarity> = {
  // Direct matches
  common: 'common',
  uncommon: 'uncommon',
  rare: 'rare',
  ultra_rare: 'ultra_rare',
  secret_rare: 'secret_rare',
  promo: 'promo',
  vintage: 'vintage',
  // Legacy mappings
  holo_rare: 'rare',
  reverse_holo: 'rare',
  super_rare: 'ultra_rare',
  full_art: 'ultra_rare',
  alternate_art: 'ultra_rare',
  special_art: 'secret_rare',
  hyper_rare: 'secret_rare',
  limited: 'vintage',
  // Pokemon-specific
  double_rare: 'ultra_rare',
  illustration_rare: 'ultra_rare',
  special_art_rare: 'secret_rare',
  shining: 'secret_rare',
  crystal: 'secret_rare',
};

export function normalizeRarity(rarity: string | null | undefined): CardRarity | null {
  if (!rarity) return null;
  const lower = rarity.toLowerCase().replace(/\s+/g, '_');
  return RARITY_MAPPING[lower] || null;
}
